import { Component, Vue } from 'vue-property-decorator'
import { get } from 'lodash'

interface DeactivateableComponent {
  appDeactivated?: () => void;
}

@Component
export default class WebComponentRootMixin extends Vue {
  deactivated () {
    this.deactivateChildren(this)
  }

  deactivateChildren (component: Vue & DeactivateableComponent) {
    if (component.$children) {
      for (const child of component.$children) {
        this.deactivateChildren(child)
      }
    }

    const deactivate = get(component, 'appDeactivated', null)

    if (typeof deactivate === 'function') {
      deactivate()
    }
  }
}
